export default "__VITE_ASSET__hUf8xbyZ__"